import { render, staticRenderFns } from "./form-richiesta-accesso.vue?vue&type=template&id=46891fe8&"
import script from "./form-richiesta-accesso.vue?vue&type=script&lang=js&"
export * from "./form-richiesta-accesso.vue?vue&type=script&lang=js&"
import style0 from "./form-richiesta-accesso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports